import { render, staticRenderFns } from "./Incomes.vue?vue&type=template&id=703aa812"
import script from "./Incomes.vue?vue&type=script&lang=js"
export * from "./Incomes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports